//FUNCIONS
import React, { useRef, useCallback, useEffect, useState } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { customerCreateRequest } from '../../../../store/modules/auth/actions';
import getValidationErrors from '../../../../utils/getValidationErrors';
import { bValidBirthDay } from '../../../../utils/bValidBirthDay';
import { bValidCpf } from '../../../../utils/bValidCpf';
import { StoreState } from '../../../../store/createStore';
import { setMessageToast } from '../../../../store/modules/parameter/actions';
import { updateCustomerCard } from '../../../../store/modules/checkout/actions';

//HOOKS

//TYPES
import { CustomerData } from '../../../../store/modules/auth/types';
//COMPONENTS
import Input from '../../../../components/Input';
import Button from '../../../../components/Button';

//STYLES
import { CreateClient, ColInput, ColButton, ContentButtonCancelProcess, ContentCreateAddress } from './styles';
import AddressCreateOrUpdate from '../../../../components/AddressCustomer/AddressCreateOrUpdate';
import { useTranslation } from '../../../../hooks/useTranslation';
import Loading from '../../../../components/Loading';
import { isAdult } from '../../../../utils/isAdult';

interface CreateCustomerProps {
  onSetCreateCustomer: (state: number) => void;
  type: number;
}

const CreateCustomer: React.FC<CreateCustomerProps> = ({ onSetCreateCustomer, type }: CreateCustomerProps) => {
  const { checkout: { customer: user } } = useSelector((state: StoreState) => state.checkout);
  const { error: errorAuth, message: messageAuth, loading: loadingAuth } = useSelector((state: StoreState) => state.auth);
  const formRef = useRef<FormHandles>(null);
  const dispatch = useDispatch();
  const [createAddress, setCreateAddress] = useState(false);
  const { onTranslation: t } = useTranslation();

  useEffect(() => {
    const functionasync = async () => {
      if (errorAuth && messageAuth) {
        await dispatch(setMessageToast({
          type: 'error', message: messageAuth
        }));
      }
    };
    functionasync();
  }, [errorAuth, messageAuth, dispatch]);

  useEffect(() => {
    const functionasync = async () => {
      if (user && type === 1) {
        if (user.data.customer.address && user.data.customer.address.length > 0) {
          setCreateAddress(false);
          onSetCreateCustomer(0);
        }
        else {
          setCreateAddress(true);
        }
      }
    };
    functionasync();
  }, [user, type, onSetCreateCustomer, dispatch]);

  const onSetCreateAddress = useCallback((state: boolean) => {
    setCreateAddress(state);
    onSetCreateCustomer(0);
  }, [setCreateAddress, onSetCreateCustomer]);

  const handleSubmit = useCallback(
    async (data: CustomerData) => {
      try {
        formRef.current?.setErrors({});

        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          first_name: Yup.string().required(`${t('main.messages_yup.name_required')}`),
          last_name: Yup.string().required(`${t('main.messages_yup.last_name_required')}`),
          email: Yup.string()
            .required(`${t('main.messages_yup.email_required')}`)
            .email(`${t('main.messages_yup.email_invalid')}`),
          customer_id: Yup.string().test({
            test: cpf_cnpj => bValidCpf(cpf_cnpj),
            message: `${t('main.messages_yup.cpf_invalid')}`
          }).test({
            test: birth => !isNaN(birth),
            message: `${t('main.messages_yup.write_only_number')}`
          }).required(`${t('main.messages_yup.cpf_required')}`),
          date_of_birth: Yup.string()
            .test({
              test: birth => !isNaN(birth),
              message: `${t('main.messages_yup.write_only_number')}`
            }).test({
              test: birth => bValidBirthDay(birth),
              message: `${t('main.messages_yup.date_of_birth_invalid')}`
            })
            .min(6, `${t('main.messages_yup.min')} 6 ${t('main.messages_yup.digits')}`).max(8, `${t('main.messages_yup.max')} 8 ${t('main.messages_yup.digits')}`)
            .required(`${t('main.messages_yup.date_of_birth_required')}`)
            .test('is-adult', 'Você deve ter pelo menos 18 anos', (birth) => isAdult(birth as string)),
          phone: Yup.string()
            .matches(/^\d{2}\d{4,5}\d{4}$/gi,
              {
                message: `${t('main.messages_yup.phone_invalid')}`
              })
            .required(`${t('main.messages_yup.phone_required')}`).test({
              test: phone_mobile => !isNaN(phone_mobile),
              message: `${t('main.messages_yup.write_only_number')}`
            }),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        if (type === 1)
          await dispatch(customerCreateRequest(data, undefined, 'customerCreateCard'));
        else if (type === 2 && user?.data.customer.id) {
          await dispatch(updateCustomerCard(data, user.data.customer.id, t('main.messages_toast.customer_update_sucess')));
        }
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);
          //konsole.log('handleSubmit errors:', errors);
        }
      }
    },
    [dispatch, type, user, t],
  );

  const handledCloseCreateClient = () => {
    onSetCreateCustomer(0);
  }

  useEffect(() => {
    if (formRef.current && user) {
      //konsole.log('carrega...', address);
      formRef.current.setData({
        first_name: user.data.customer.first_name,
        last_name: user.data.customer.last_name,
        customer_id: user.data.customer.customer_id,
        email: user.data.customer.email,
        date_of_birth: `${user.data.customer.date_of_birth?.slice(8, 10)}${user.data.customer.date_of_birth?.slice(5, 7)}${user.data.customer.date_of_birth?.slice(0, 4)}`,
        phone: user.data.customer.phone,
      });
    }
  }, [user]);

  return (
    <>
      {
        !createAddress ? (
          <CreateClient>
            <span>{t('main.new_checkout.view_checkout.create_customer.create_customer')}</span>
            <Form
              ref={formRef}
              onSubmit={handleSubmit}
            >
              <ColInput>
                <Input
                  name="first_name"
                  textLabel={`${t('main.new_account.account_data.input_name')}`}
                  Border="1px solid var(--primary)"
                  formRef={formRef}
                />
                <Input
                  name="last_name"
                  textLabel={`${t('main.new_account.account_data.input_last_name')}`}
                  Border="1px solid var(--primary)"
                  formRef={formRef}
                />
              </ColInput>

              <ColInput>
                <Input
                  textLabel={`${t('main.new_account.account_data.input_cpf')}`}
                  name="customer_id"
                  Border="1px solid var(--primary)"
                  mask="###.###.###-##"
                  formRef={formRef}
                />
                <Input
                  name="email"
                  textLabel={`${t('main.new_account.account_data.input_email')}`}
                  Border="1px solid var(--primary)"
                  formRef={formRef}
                />
              </ColInput>

              <ColInput>
                <Input
                  textLabel={`${t('main.new_account.account_data.input_date_of_birth')}`}
                  name="date_of_birth"
                  mask="##/##/####"
                  Border="1px solid var(--primary)"
                  formRef={formRef}
                />
                <Input
                  textLabel={`${t('main.new_account.account_data.input_cpf')}`}
                  name="customer_id"
                  Border="1px solid var(--primary)"
                  mask="###.###.###-##"
                  formRef={formRef}
                />
              </ColInput>

              <ColButton>
                <Button
                  button={{ type: 'submit' }}
                  atributes={{
                    buttonType: 'primary',
                    textColor: '#fff',
                    textSize: '30px',
                    borderColor: '#dddddd',
                  }}
                >
                  {loadingAuth ? (
                    <Loading size={30} />
                  ) : (
                      <>
                        {!loadingAuth && type === 1 && t('main.globals.next_step')}
                        {!loadingAuth && type === 2 && t('main.globals.save')}
                      </>
                    )}
                </Button>
              </ColButton>
            </Form>
          </CreateClient>

        ) : (
            <ContentCreateAddress>
              <span>{t('main.new_checkout.view_checkout.create_customer.create_address')}</span>
              <AddressCreateOrUpdate onSetModal={onSetCreateAddress} />
            </ContentCreateAddress>
          )
      }
      {
        <ContentButtonCancelProcess>
          <Button
            button={{ type: 'button' }}
            onClick={handledCloseCreateClient}
            atributes={{
              buttonType: 'outline',
              borderColor: 'var(--primary)',
              textColor: '#000',
            }}
          >
            {t('main.globals.cancel')}
          </Button>
        </ContentButtonCancelProcess>
      }
    </>
  )
}

export default CreateCustomer;